export const WOO_COMMERCE_GATEWAYS = [];
